<template>
  <div class="not-found-container">
    <div class="not-found-content">
      <div class="brand-logo-container">
        <img src="~@/assets/images/login-logo.png" class="brand-logo" alt="Logo" />
      </div>
      <h1 class="error-title">
        <span class="nowrap-text">404 - Page Not Found</span>
      </h1>
      <p class="error-message">Halaman yang kamu cari tidak ditemukan.</p>
      <button type="button" class="btn btn-primary" @click="backToHomePage">
        Kembali ke beranda
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundPage',
  methods: {
    backToHomePage() {
      this.$router.push('/');
    },
  },
};
</script>

<style scoped>
.nowrap-text {
  white-space: nowrap;
    text-align: center;
}
.not-found-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f9f9f9;
}

.not-found-content {
  text-align: center;
  width: 300px;
}

.brand-logo-container {
  height: 170px;
  width: 170px;
  border-radius: 50%;
  background: #fff;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 20px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
}

.brand-logo {
  height: 150px;
  width: 150px;
  border-radius: 50%;
  border: 2px solid #fff;
  object-fit: cover;
}

.error-title {
  color: #2797fb;
  margin-bottom: 10px;
}

.error-message {
  margin-bottom: 20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/NotFoundPage.vue